module.exports = __webpack_public_path__ + "img/2015085.1fd3b511.svg";